import { Component } from 'react'
import { set as setCookie } from 'es-cookie'
import { integrationValidateShortLinkService } from '../../api/integration'
import { getSessionCookieOptions } from '../../utils/cookie-options'
import {
  getMcpAuthorizeReturnUrl,
  startMcpConnect,
} from '../../utils/mcp-oauth-handoff'

class EnoctaReroute extends Component {
  checkToken = async (shortLink, mcpReturnUrl) => {
    //let response = await integrationValidateTokenService(token)

    let response = await integrationValidateShortLinkService(shortLink)
    if (response.data != null) {
      setCookie('token', response.data.accessToken, getSessionCookieOptions())
      setCookie('refreshToken', response.data.refreshToken, getSessionCookieOptions())
      setCookie('userId', response.data.userId, getSessionCookieOptions())
      //setCookie('token', token)

      // If this external login was part of the MCP connector OAuth flow, finish that flow (via
      // the workspace picker).
      if (mcpReturnUrl && startMcpConnect(mcpReturnUrl)) {
        return
      }

      if (response.data.firstLogin) {
        setCookie('email', response.data.userName, getSessionCookieOptions())

        window.location.href = '/purpose'
      } else {
        window.location.href = '/'
      }
    } else {
      window.location.href = '/login'
    }
  }

  /**
   *
   */
  render() {
    // Parse query params robustly: the backend may append &returnUrl=… after shortLink.
    const params = new URLSearchParams(window.location.search)
    const shortLink = params.get('shortLink')
    const mcpReturnUrl = getMcpAuthorizeReturnUrl()

    if (shortLink) {
      this.checkToken(shortLink, mcpReturnUrl)
    }

    return ''
  }
}

export default EnoctaReroute
